<ng-template #modalContent let-modal>
  <div class="modal-header border-bottom p-3">
    <h6 id="offcanvasAddUserLabel" class="offcanvas-title">
      {{ "ChangePassword" | translate }}
    </h6>
    <button
      type="button"
      class="btn-close close-modal-button text-reset"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body mx-0 flex-grow-0">
    <div class="row m-0">
      <div
        class="col-12 col-md-6 col-lg-6 col-sm-6 col-xxl-6 mb-3"
        *ngIf="needOldPassword"
      >
        <div class="edit-form">
          <label class="form-label" for="password">
            {{ "oldPassword" | translate }}
          </label>
          <div class="validation-alert-pc-modal">
            <p>
              {{ componentData.oldPasswordErrorMessage! | translate }}
            </p>
          </div>
          <input
            id="oldPassword"
            name="oldPassword"
            type="password"
            class="form-control text-start"
            [ngClass]="{
              'is-invalid': componentData.oldPasswordErrorMessage != undefined
            }"
            placeholder="{{ 'oldPassword' | translate }}"
            aria-describedby="oldPassword"
            [(ngModel)]="componentData.oldPassword"
          />
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-6 col-sm-6 col-xxl-6 mb-3">
        <div class="edit-form">
          <label class="form-label" for="password">
            {{ "newPassword" | translate }}
          </label>
          <div class="validation-alert-pc-modal">
            <p>
              {{ componentData.newPasswordErrorMessage! | translate }}
            </p>
          </div>
          <input
            id="newPassword"
            name="newPassword"
            type="password"
            class="form-control text-start"
            [ngClass]="{
              'is-invalid': componentData.newPasswordErrorMessage != undefined
            }"
            placeholder="{{ 'newPassword' | translate }}"
            aria-describedby="newPassword"
            [(ngModel)]="componentData.newPassword"
          />
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-6 col-sm-6 col-xxl-6 mb-3">
        <div class="edit-form">
          <label class="form-label" for="password">
            {{ "newPasswordAgain" | translate }}
          </label>
          <div class="validation-alert-pc-modal">
            <p>
              {{ componentData.confirmPasswordErrorMessage! | translate }}
            </p>
          </div>
          <input
            id="confirmPassword"
            name="confirmPassword"
            type="password"
            [ngClass]="{
              'is-invalid':
                componentData.confirmPasswordErrorMessage != undefined
            }"
            class="form-control text-start"
            placeholder="{{ 'newPasswordAgain' | translate }}"
            aria-describedby="confirmPassword"
            [(ngModel)]="componentData.confirmPassword"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer border-top p-3">
    <button
      type="submit"
      class="btn btn-primary me-sm-3 me-1 data-submit"
      (click)="onSubmit()"
    >
      {{ "Submit" | translate }}
    </button>
    <button
      type="reset"
      class="btn btn-label-secondary"
      (click)="modal.dismiss('Cross click')"
    >
      {{ "Cancel" | translate }}
    </button>
  </div>
  <app-loading-panel *ngIf="loading"></app-loading-panel>
</ng-template>
